/* EF_MEASUREMENT_INPUT_20260912: keep accessory recommendations off the
   measurement keystroke path. Door validation and pricing remain synchronous.
   One queue covers all cards; blur/change flush before the shopper continues. */
var efAccWidthQueue = (function () {
  var input = null, callbacks = [], timer = null, pending = false, lastValue = null;
  function flush() {
    clearTimeout(timer); timer = null;
    if (!pending || !input) return;
    pending = false;
    var value = input.value;
    if (value === lastValue) return;
    lastValue = value;
    callbacks.forEach(function (refresh) { refresh(); });
  }
  function schedule() {
    pending = true;
    clearTimeout(timer);
    timer = setTimeout(flush, 200);
  }
  return function (refresh) {
    if (!input) {
      input = document.getElementById('efCfgWidth');
      if (!input) return;
      lastValue = input.value;
      input.addEventListener('input', schedule);
      input.addEventListener('change', function () { pending = true; flush(); });
      input.addEventListener('blur', flush);
      document.addEventListener('click', function (event) {
        if (pending && event.target.closest && event.target.closest('#efCfgNext, #efCfgATC, #efPd2StickyAtc')) flush();
      }, true);
    }
    callbacks.push(refresh);
  };
}());

/* efx-accessories.js — the rebuilt door-PDP accessory offer. T-UPSELL, 2026-09-01.
 * Markup: snippets/efx-accessories.liquid + snippets/efx-accessory-card.liquid
 *
 * THREE behaviours, none of them on the door's order path:
 *
 *   1. RAIL ADD (module B). One delegated listener. POST /cart/add.js with {items:[{id,quantity}]}
 *      and NO line-item properties — an accessory must be an ordinary cart line that the cart's
 *      surcharge orphan-cleanup never looks at. It carries neither _parent_product nor
 *      _config_id, by design and by gate.
 *
 *   2. SCROLL PROGRESS (module B). Presentational. The rail scrolls natively with or without it.
 *
 *   3. REVIEW-STEP ATTACH (module A). The ticked accessories are added AFTER the door add has
 *      already succeeded, as one separate request.
 *
 *      How the success is detected, and why it is detected this way: the configurator's own
 *      add path (assets/ef-configurator-v2.js) does not emit an event on success — it sets the
 *      ATC button's text to "Added to Cart ✓" and opens the drawer 800 ms later. That file is
 *      owned by another lane today and is explicitly out of bounds for this task, so this
 *      module WATCHES the button rather than editing the code behind it: a MutationObserver on
 *      #efCfgATC, one-shot per add.
 *
 *      The failure direction is the safe one. If that button's text ever changes, this hook
 *      silently stops firing: the accessory is not added, and the door — the line worth 2-20x
 *      more — is completely unaffected. Nothing here can block, delay or reverse the door add,
 *      because everything here happens after it has already been banked. A rejected accessory
 *      request is logged and swallowed for the same reason.
 *
 * No file under ef-cfg-*, ef-configurator-v2*, ef-orderform-* or ef-cart-drawer* is touched by
 * this script, and it never writes configurator state.
 */
(function () {
  'use strict';

  var money = function (cents) {
    var v = cents / 100;
    var s = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || ('cart ' + r.status)); });
      return r.json();
    });
  }

  function refreshCart() {
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
  }

  /* ---------------------------------------------------------------- 1. rail add */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-efx-acc-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;

    var label = btn.querySelector('.efx-uab__add-label') || btn;
    var original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding…';

    var item = { id: id, quantity: 1 }; var finv = btn.getAttribute('data-efx-finish-value'); if (finv) item.properties = { Finish: finv };   /* DIRECT-2n */
    addToCart([item]).then(function () {
      label.textContent = 'Added ✓';
      btn.classList.add('is-done');
      refreshCart();
      if (window.EFCartDrawer && typeof window.EFCartDrawer.open === 'function') window.EFCartDrawer.open();
      setTimeout(function () {
        label.textContent = original;
        btn.classList.remove('is-done');
        btn.disabled = false;
      }, 2600);
    }).catch(function (err) {
      console.error('[efx-acc] add failed', err);
      label.textContent = 'Try again';
      setTimeout(function () { label.textContent = original; btn.disabled = false; }, 2200);
    });
  }, false);

  /* --------------------------------------------------- 2. rail scroll progress */
  function wireRail(rail) {
    var bar = rail.closest('.efx-uab').querySelector('[data-efx-uab-bar]');
    if (!bar) return;
    var paint = function () {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 2) { bar.parentElement.style.display = 'none'; return; }
      bar.parentElement.style.display = '';
      var frac = rail.clientWidth / rail.scrollWidth;
      var w = Math.max(0.12, Math.min(1, frac));
      bar.style.width = (w * 100).toFixed(2) + '%';
      var travel = (1 - w) * rail.clientWidth;
      bar.style.transform = 'translateX(' + ((rail.scrollLeft / max) * travel).toFixed(1) + 'px)';
    };
    rail.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    if (window.ResizeObserver) { try { new ResizeObserver(paint).observe(rail); } catch (e) {} }
    paint();
  }

  /* ------------------------------------------- 3. review-step attach (module A) */
  function wireReview(mod) {
    var note = mod.querySelector('[data-efx-uac-note]');
    var ticks = function () { return [].slice.call(mod.querySelectorAll('[data-efx-acc-tick]')); };

    function selected() { return ticks().filter(function (t) { return t.checked; }); }

    function paintNote() {
      if (!note) return;
      var sel = selected();
      if (!sel.length) { if (!note.hidden) note.hidden = true; if (note.childNodes.length) note.innerHTML = ''; paintWith(null, 0); return; }   /* DIRECT-2g — clear the button too */
      var total = sel.reduce(function (a, t) { return a + (parseInt(t.getAttribute('data-price'), 10) || 0); }, 0);
      var word = sel.length === 1 ? 'accessory' : 'accessories';
      /* Said plainly, because the Total below this module is the door's total: these lines are
         added to the cart alongside the door, not folded into that figure. */
      /* DIRECT-1r — the combined figure: the door's own total (engine-written #efCfgTotalPrice) + the ticked
         accessories. Painted beside the engine's label (attribute + CSS), in this note, and under the
         companion's Total. The engine's nodes are never rewritten. */
      var doorCents = parseDoorTotal();
      var withCents = doorCents != null ? doorCents + total : null;
      note.innerHTML = '<b>' + sel.length + ' ' + word + ' · ' + money(total) + '</b>' + (withCents != null ? ' — your order comes to <b>' + money(withCents) + '</b> (door ' + money(doorCents) + ' + accessories).' : ' — added to your cart alongside your door.');
      note.hidden = false;
      paintWith(withCents, sel.length);
    }
    function parseDoorTotal() {
      var el = document.getElementById('efCfgTotalPrice'); if (!el) return null;
      var m = String(el.textContent || '').replace(/,/g, '').match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
      return m ? Math.round(parseFloat(m[1]) * 100) : null;
    }
    function visibleAtc() {
      var bs = document.querySelectorAll('#efCfg button, #efCfg a.ef-cfg-btn');
      for (var i = 0; i < bs.length; i++) { var b = bs[i]; if (/^\s*Add to Cart/i.test(b.textContent || '') && b.offsetParent !== null) return b; }
      return null;
    }
    function paintWith(withCents, n) {
      /* No selected accessories: clear stale mirrors without measuring hidden
         purchase controls. Model-price changes often arrive while typing sizes. */
      if (withCents == null || n <= 0) {
        document.querySelectorAll('#efCfg [data-efx-with]').forEach(function(button) { button.removeAttribute('data-efx-with'); });
        var oldWith = document.querySelector('[data-efx-uac-with]');
        if (oldWith) oldWith.remove();
        return;
      }
      var btn = visibleAtc();
      if (btn) { if (withCents != null && n > 0) btn.setAttribute('data-efx-with', money(withCents)); else btn.removeAttribute('data-efx-with'); }
      var tot = document.querySelector('[data-efx-companion-total]');
      if (tot) {
        var row = tot.parentElement; if (!row) return;
        var line = row.parentElement && row.parentElement.querySelector('[data-efx-uac-with]');
        if (withCents == null || n <= 0) { if (line) line.remove(); return; }
        if (!line) { line = document.createElement('div'); line.className = 'efx-uac__with'; line.setAttribute('data-efx-uac-with', ''); row.insertAdjacentElement('afterend', line); }
        line.innerHTML = '<span>With ' + n + (n === 1 ? ' accessory' : ' accessories') + '</span><b>' + money(withCents) + '</b>';
      }
    }
    /* the engine re-renders its total on every change; keep the combined figure in step */
    (function () {
      var tp = document.getElementById('efCfgTotalPrice');
      if (tp && window.MutationObserver) new MutationObserver(function () { paintNote(); }).observe(tp, { childList: true, characterData: true, subtree: true });
      var sh = document.querySelector('.ef-cfg-step[id="efCfgStepReview"]');
      if (sh && window.MutationObserver) new MutationObserver(function () { if (selected().length) paintNote(); }).observe(sh, { attributes: true, attributeFilter: ['class'] });
    }());

    mod.addEventListener('change', function (ev) {
      // Model and gas-log selectors update the existing tick's native price,
      // then emit change on this module. Refresh the same receipt for both
      // those updates and checkbox changes; no new calculation or cart action.
      paintNote();
    });
    paintNote();

    /* Watch the configurator's own ATC button for its success state. */
    var atc = document.getElementById('efCfgATC');
    if (!atc || !window.MutationObserver) return;
    var busy = false;

    var onSuccess = function () {
      if (busy) return;
      var sel = selected();
      if (!sel.length) return;
      busy = true;
      var items = sel.map(function (t) {
        var it = { id: parseInt(t.getAttribute('data-variant-id'), 10), quantity: 1 };
        var fin = t.getAttribute('data-efx-finish-value'); if (fin) it.properties = { 'Finish': fin, '_bundle': 'door' };
        return it;
      }).filter(function (i) { return !!i.id; });
      if (!items.length) { busy = false; return; }

      /* Sequential, never concurrent with the door add: we are already past it. */
      addToCart(items).then(function () {
        sel.forEach(function (t) { t.checked = false; });
        paintNote();
        refreshCart();
      }).catch(function (err) {
        /* Never surfaced as a blocking error and never retried automatically — the door is
           banked and a failed accessory must not turn a completed sale into an error state. */
        console.error('[efx-acc] review attach failed', err);
      }).then(function () {
        setTimeout(function () { busy = false; }, 4000);
      });
    };

    new MutationObserver(function () {
      var t = (atc.textContent || '');
      if (/added to cart/i.test(t)) onSuccess();
    }).observe(atc, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    [].slice.call(document.querySelectorAll('[data-efx-uab-rail]')).forEach(wireRail);
    [].slice.call(document.querySelectorAll('[data-efx-uac]')).forEach(wireReview);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* DIRECT-1t — upsell v3 helpers. Read-only against the wizard (#efCfgWidth, the chapter-4 swatch). */
(function () {
  function inches(s) { s = String(s || '').trim(); if (!s) return NaN; var m = s.match(/^(\d+)(?:[\s-]+(\d+)\/(\d+))?/); if (m) { var v = parseFloat(m[1]); if (m[2] && m[3]) v += parseFloat(m[2]) / parseFloat(m[3]); return v; } var f = parseFloat(s.replace(/[^0-9.]/g, '')); return isFinite(f) ? f : NaN; }
  function fmt(c) { c = Math.round(c) / 100; return '$' + (c % 1 ? c.toFixed(2) : c.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function widthIn() { var w = document.getElementById('efCfgWidth'); var v = w ? inches(w.value) : NaN; return isFinite(v) && v > 0 ? v : NaN; }
  function pingModule(el) { var mod = el.closest('[data-efx-uac]'); if (mod) mod.dispatchEvent(new Event('change', { bubbles: true })); }
  function sizeOf(s) { var m = String(s || '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; }

  /* gas-log cards */
  var cards = [].slice.call(document.querySelectorAll('[data-efx-gls] [data-efx-gl]:not([data-efx-gl-family]):not([data-efx-gl-v5])'));
  cards.forEach(function (card) {
    var variants, options;
    try { variants = JSON.parse(card.getAttribute('data-efx-gl-variants') || '[]'); options = JSON.parse(card.getAttribute('data-efx-gl-options') || '[]'); } catch (e) { return; }
    var sels = [].slice.call(card.querySelectorAll('[data-efx-gl-opt]')), tick = card.querySelector('[data-efx-acc-tick]'), price = card.querySelector('[data-efx-gl-price]'), lab = card.querySelector('[data-efx-gl-size-label]'), fit = card.querySelector('[data-efx-gl-fit]');
    /* DIRECT-1u: `product.options | json` is an array of option NAMES; the values live in the selects. */
    options = options.map(function (o) { return typeof o === 'string' ? { name: o, values: [] } : (o || { name: '', values: [] }); });
    var sizeIdx = -1;
    options.forEach(function (o, i) { if (/size/i.test(String(o.name || ''))) sizeIdx = i; });
    if (sizeIdx < 0) sels.forEach(function (s) { var first = s.options[0] ? s.options[0].value : ''; if (/^\d+(\.\d+)?\s*("|\u2033|in\b)/.test(first)) sizeIdx = parseInt(s.getAttribute('data-efx-gl-opt'), 10); });
    if (sizeIdx < 0 && sels.length === 1) sizeIdx = parseInt(sels[0].getAttribute('data-efx-gl-opt'), 10);
    function chosen() { var o = []; sels.forEach(function (s) { o[parseInt(s.getAttribute('data-efx-gl-opt'), 10)] = s.value; }); return o; }
    function resolve() {
      if (!sels.length) return variants[0] || null;
      var o = chosen();
      for (var i = 0; i < variants.length; i++) { var v = variants[i]; var ok = true; for (var k = 0; k < o.length; k++) { if (o[k] != null && v.o[k] !== o[k]) { ok = false; break; } } if (ok) return v; }
      return null;
    }
    function paint() {
      var v = resolve();
      if (!v) { if (price) price.textContent = '—'; tick.disabled = true; return; }
      tick.disabled = !v.a; tick.setAttribute('data-variant-id', v.id); tick.setAttribute('data-price', v.p);
      if (price) price.textContent = fmt(v.p);
      if (lab) { if (sizeIdx >= 0) lab.textContent = chosen()[sizeIdx] || ''; else { lab.textContent = ''; var sep = card.querySelector('[data-efx-gl-sep]'); if (sep) sep.textContent = ''; } }
      if (fit && sizeIdx >= 0) { var w = widthIn(); fit.textContent = isFinite(w) ? 'Sized for your ' + w.toFixed(w % 1 ? 1 : 0).replace(/\.0$/, '') + '\u2033 opening \u2014 the longest set that leaves 3\u2033 each side.' : 'Sized to your width once you type it.'; }
      pingModule(card);
    }
    /* the other selects default to the CHEAPEST available variant of the chosen size (match light, natural gas) */
    function cheapest() {
      var sz = sizeIdx >= 0 ? chosen()[sizeIdx] : null; var bestV = null;
      variants.forEach(function (v) { if (!v.a) return; if (sz != null && v.o[sizeIdx] !== sz) return; if (!bestV || v.p < bestV.p) bestV = v; });
      if (!bestV) return;
      sels.forEach(function (s) { var k = parseInt(s.getAttribute('data-efx-gl-opt'), 10); if (k === sizeIdx) return; for (var i = 0; i < s.options.length; i++) if (s.options[i].value === bestV.o[k]) { s.selectedIndex = i; break; } });
    }
    function fromWidth() {
      var w = widthIn(); var sel = sizeIdx >= 0 ? sels.find(function (s) { return parseInt(s.getAttribute('data-efx-gl-opt'), 10) === sizeIdx; }) : null;
      if (sel && isFinite(w)) { var best = -1, bestL = -1; for (var i = 0; i < sel.options.length; i++) { var L = sizeOf(sel.options[i].value); if (isFinite(L) && L <= w - 6 && L > bestL) { best = i; bestL = L; } } if (best < 0) best = 0; sel.selectedIndex = best; }
      cheapest();
      paint();
    }
    sels.forEach(function (s) { s.addEventListener('change', paint); });
    efAccWidthQueue(fromWidth);
    fromWidth();
  });

  /* strip arrows */
  var strip = document.querySelector('[data-efx-gls]');
  if (strip) {
    var track = strip.querySelector('[data-efx-gls-track]');
    var step = function () { var c = track.querySelector('[data-efx-gl]'); return c ? c.getBoundingClientRect().width + 14 : 320; };
    var prev = strip.querySelector('[data-efx-gls-prev]'), next = strip.querySelector('[data-efx-gls-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }


  /* finish select → line-item property; "Match my door" resolves to the chapter-4 swatch at add time */
  function doorFinish() { var sw = document.querySelector('#efCfgSwatchGrid .ef-cfg-swatch[aria-checked="true"]'); return sw ? (sw.getAttribute('data-label') || sw.textContent.trim()) : ''; }
  [].slice.call(document.querySelectorAll('[data-efx-uac] [data-efx-finish], [data-efx-uab-rail] [data-efx-finish]')).forEach(function (sel) {
    var row0 = sel.closest('.efx-uac__row, .efx-uab__card'); var tick = row0 && row0.querySelector('[data-efx-acc-tick], [data-efx-acc-add]'); if (!tick) return;
    function apply() { var v = sel.value === 'Match my door' ? (doorFinish() || 'Match my door') : sel.value; tick.setAttribute('data-efx-finish-value', v); }
    sel.addEventListener('change', apply); apply();
    var grid = document.getElementById('efCfgSwatchGrid'); if (grid && window.MutationObserver) new MutationObserver(apply).observe(grid, { attributes: true, subtree: true, attributeFilter: ['aria-checked'] });
  });
}());

/* DIRECT-1x — model select per accessory row, grate recommendation by width, photo zoom. */
(function () {
  function inches(s) { s = String(s || '').trim(); if (!s) return NaN; var m = s.match(/^(\d+)(?:[\s-]+(\d+)\/(\d+))?/); if (m) { var v = parseFloat(m[1]); if (m[2] && m[3]) v += parseFloat(m[2]) / parseFloat(m[3]); return v; } var f = parseFloat(s.replace(/[^0-9.]/g, '')); return isFinite(f) ? f : NaN; }
  function fmt(c) { c = Math.round(c) / 100; return '$' + (c % 1 ? c.toFixed(2) : c.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function widthIn() { var w = document.getElementById('efCfgWidth'); var v = w ? inches(w.value) : NaN; return isFinite(v) && v > 0 ? v : NaN; }
  [].slice.call(document.querySelectorAll('[data-efx-uac] [data-efx-model], [data-efx-uab-rail] [data-efx-model]')).forEach(function (sel) {
    var row = sel.closest('.efx-uac__row, .efx-uab__card'); if (!row) return;   /* DIRECT-2n — the rail family card too */
    var tick = row.querySelector('[data-efx-acc-tick], [data-efx-acc-add]'), name = row.querySelector('.efx-uac__name, .efx-uab__name'), price = row.querySelector('.efx-uac__price, .efx-uab__price'), media = row.querySelector('[data-efx-model-img]'), isRail = row.classList.contains('efx-uab__card');
    var isGrate = sel.hasAttribute('data-efx-model-grate');
    function apply() {
      var o = sel.options[sel.selectedIndex]; if (!o || !tick) return;
      tick.setAttribute('data-variant-id', o.value); tick.setAttribute('data-price', o.getAttribute('data-price') || '');
      var n = o.getAttribute('data-name') || ''; tick.setAttribute('data-name', n);
      if (name && !row.hasAttribute('data-efx-family')) name.textContent = n; if (price) price.textContent = fmt(parseFloat(o.getAttribute('data-price') || '0'));
      var al = row.querySelector('.efx-uab__add-label'); if (al) al.textContent = 'Add \u2014 ' + fmt(parseFloat(o.getAttribute('data-price') || '0'));
      var src = o.getAttribute('data-img'); if (src && isRail) { src = src.replace(/width=160/, 'width=560'); var im0 = media && media.querySelector('img'); if (im0) im0.removeAttribute('srcset'); } if (media && src) { var img = media.querySelector('img'); if (!img) { media.innerHTML = ''; img = document.createElement('img'); img.width = 64; img.height = 64; img.alt = ''; media.appendChild(img); } if (img.getAttribute('src') !== src) img.src = src; var zb = media.querySelector('[data-efx-zoom]'); if (zb) zb.setAttribute('data-efx-zoom', src.replace(/width=160/, 'width=1200')); media.classList.add('efx-uac__media--zoom'); if (!zb) { zb = document.createElement('button'); zb.type = 'button'; zb.className = 'efx-uac__zoom'; zb.setAttribute('aria-label', 'Enlarge the photo'); zb.setAttribute('data-efx-zoom', src.replace(/width=160/, 'width=1200')); zb.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg>'; media.appendChild(zb); } }
      var mod = row.closest('[data-efx-uac]'); if (mod) mod.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function recommend() {
      if (!isGrate) return; var w = widthIn(); var best = -1, bestL = -1;
      for (var i = 0; i < sel.options.length; i++) { var o = sel.options[i]; var base = (o.getAttribute('data-name') || '') + ' \u2014 ' + fmt(parseFloat(o.getAttribute('data-price') || '0')); o.textContent = base; var L = parseFloat(o.getAttribute('data-sz')); if (isFinite(w) && isFinite(L) && L <= w - 6 && L > bestL) { best = i; bestL = L; } }
      if (best >= 0) { sel.options[best].textContent += ' \u00b7 recommended'; sel.selectedIndex = best; }
      apply();
    }
    sel.addEventListener('change', apply);
    if (isGrate) { efAccWidthQueue(recommend); recommend(); } else apply();
  });
  /* zoom: any [data-efx-zoom] opens the large photo in a body-level modal */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-efx-zoom]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var wrap = document.createElement('div'); wrap.className = 'efx-lintel-modal'; wrap.setAttribute('role', 'presentation');
    var card = document.createElement('div'); card.className = 'efx-lintel-pop__card'; card.setAttribute('role', 'dialog'); card.setAttribute('aria-modal', 'true'); card.setAttribute('aria-label', 'Product photo');
    card.innerHTML = '<button type="button" class="efx-lintel-pop__close" aria-label="Close">\u00d7</button><img src="' + b.getAttribute('data-efx-zoom') + '" alt="">';
    wrap.appendChild(card); document.body.appendChild(wrap);
    var closeButton = card.querySelector('button');
    closeButton.focus();
    function close() { wrap.remove(); document.removeEventListener('keydown', onKey); if (b.isConnected) b.focus(); }
    function onKey(ev) { if (ev.key === 'Escape') { ev.preventDefault(); close(); } else if (ev.key === 'Tab') { ev.preventDefault(); closeButton.focus(); } }
    wrap.addEventListener('click', function (ev) { if (ev.target === wrap || ev.target.closest('.efx-lintel-pop__close')) close(); });
    document.addEventListener('keydown', onKey);
  }, true);
}());

/* DIRECT-2a → DIRECT-2n — horizontal rails: the home rail's own arrow component (.efx-rail__nav, efx.css) placed over
   the rail at image mid-height, and the home rail's drag (pointer capture only after 5 px, snap off while dragging,
   a drag never opens a card). Applies to "Not this one?" and both Finishing-touches rails. */
(function () {
  function scroller(root) { var els = root.querySelectorAll('*'); for (var i = 0; i < els.length; i++) { var cs = getComputedStyle(els[i]); if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && els[i].scrollWidth > els[i].clientWidth + 4) return els[i]; } return null; }
  function arm(root) {
    var track = scroller(root); if (!track || track.hasAttribute('data-efx-armed')) return; track.setAttribute('data-efx-armed', '');
    /* the arrows hang on the inner container (a full-bleed section would put them off-screen) */
    var host = root.querySelector('.efx-container') || root; host.classList.add('efx-railhost');
    function mk(dir) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'efx-rail__nav efx-rail__nav--' + (dir < 0 ? 'prev' : 'next'); b.setAttribute('aria-label', dir < 0 ? 'Previous' : 'More');
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (dir < 0 ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>';
      b.addEventListener('click', function () { if (b.classList.contains('is-end')) return; var c = track.firstElementChild; var step = c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; track.scrollBy({ left: dir * step, behavior: 'smooth' }); });
      host.appendChild(b); return b;
    }
    var prev = mk(-1), next = mk(1);
    function place() { var img = track.querySelector('img'); var ref = img || track.firstElementChild; if (!ref) return; var r = ref.getBoundingClientRect(), h = host.getBoundingClientRect(); var top = Math.round(r.top - h.top + r.height / 2 - 22); prev.style.top = top + 'px'; next.style.top = top + 'px'; }
    function sync() { var can = track.scrollWidth - track.clientWidth > 8; host.classList.toggle('is-scrollable', can); prev.classList.toggle('is-end', !can || track.scrollLeft < 8); next.classList.toggle('is-end', !can || track.scrollLeft > track.scrollWidth - track.clientWidth - 8); }
    var down = false, startX = 0, startScroll = 0, moved = 0, pid = null, captured = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch' || e.button !== 0) return; down = true; moved = 0; startX = e.clientX; startScroll = track.scrollLeft; pid = e.pointerId; });
    track.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - startX; moved = Math.max(moved, Math.abs(dx)); if (!captured && moved > 5) { captured = true; track.classList.add('is-dragging'); try { track.setPointerCapture(pid); } catch (_) {} } if (captured) track.scrollLeft = startScroll - dx; });
    var release = function (e) { if (!down) return; down = false; track.classList.remove('is-dragging'); if (captured) { captured = false; try { track.releasePointerCapture(e.pointerId); } catch (_) {} } };
    track.addEventListener('pointerup', release); track.addEventListener('pointercancel', release);
    track.addEventListener('click', function (e) { if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', function () { place(); sync(); });
    place(); sync(); setTimeout(function () { place(); sync(); }, 900);
    if (window.ResizeObserver) { try { new ResizeObserver(function () { place(); sync(); }).observe(track); } catch (e) {} }
  }
  var sib = document.getElementById('efxPdpSiblings') || document.querySelector('[class*="efx-sib"]'); if (sib) arm(sib);
  [].slice.call(document.querySelectorAll('[data-efx-uab-gl], [data-efx-uab-rail]')).forEach(function (track) {
    var host = document.createElement('div'); host.className = 'efx-railwrap'; track.parentNode.insertBefore(host, track); host.appendChild(track); arm(host);
  });
}());

/* DIRECT-2b — family cards (sizes are separate products): the select swaps variant, price, photo and link; the
   size follows the typed width (longest ≤ width − 6″). */
(function () {
  function inches(s) { s = String(s || '').trim(); if (!s) return NaN; var m = s.match(/^(\d+)(?:[\s-]+(\d+)\/(\d+))?/); if (m) { var v = parseFloat(m[1]); if (m[2] && m[3]) v += parseFloat(m[2]) / parseFloat(m[3]); return v; } var f = parseFloat(s.replace(/[^0-9.]/g, '')); return isFinite(f) ? f : NaN; }
  function fmt(c) { c = Math.round(c) / 100; return '$' + (c % 1 ? c.toFixed(2) : c.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function widthIn() { var w = document.getElementById('efCfgWidth'); var v = w ? inches(w.value) : NaN; return isFinite(v) && v > 0 ? v : NaN; }
  [].slice.call(document.querySelectorAll('[data-efx-gl-family]')).forEach(function (card) {
    var sel = card.querySelector('[data-efx-gl-fam-select]'), tick = card.querySelector('[data-efx-acc-tick]'), price = card.querySelector('[data-efx-gl-price]'), lab = card.querySelector('[data-efx-gl-size-label]'), fit = card.querySelector('[data-efx-gl-fit]'), more = card.querySelector('[data-efx-gl-more]'), media = card.querySelector('[data-efx-model-img]');
    if (!sel || !tick) return;
    function apply(fromWidth) {
      var o = sel.options[sel.selectedIndex]; if (!o) return;
      tick.setAttribute('data-variant-id', o.value); tick.setAttribute('data-price', o.getAttribute('data-price') || '');
      if (price) price.textContent = fmt(parseFloat(o.getAttribute('data-price') || '0'));
      if (lab) lab.textContent = (o.getAttribute('data-in') || '') + '\u2033';
      if (more && o.getAttribute('data-url')) more.href = o.getAttribute('data-url');
      var src = o.getAttribute('data-img'); if (media && src) { var img = media.querySelector('img'); if (img && img.getAttribute('src') !== src) img.src = src; var z = media.querySelector('[data-efx-zoom]'); if (z) z.setAttribute('data-efx-zoom', src.replace(/width=160/, 'width=1200')); }
      if (fit) { var w = widthIn(); fit.textContent = isFinite(w) ? (fromWidth ? 'Sized for your ' + w.toFixed(w % 1 ? 1 : 0).replace(/\.0$/, '') + '\u2033 opening.' : 'Your opening is ' + w.toFixed(w % 1 ? 1 : 0).replace(/\.0$/, '') + '\u2033 wide.') : 'Sized to your width once you type it.'; }
      var mod = card.closest('[data-efx-uac]'); if (mod) mod.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function fromWidth() { var w = widthIn(); if (isFinite(w)) { var best = -1, bestL = -1; for (var i = 0; i < sel.options.length; i++) { var L = parseFloat(sel.options[i].getAttribute('data-in')); if (isFinite(L) && L <= w - 6 && L > bestL) { best = i; bestL = L; } } if (best < 0) best = 0; sel.selectedIndex = best; } apply(true); }
    sel.addEventListener('change', function () { apply(false); });
    efAccWidthQueue(fromWidth);
    fromWidth();
  });
}());

/* Fit photos: automatic desktop QR, one resumable session and one poll loop. */
(function(){
  var boxes=[].slice.call(document.querySelectorAll('[data-efx-uqr]'));
  var cfg=document.getElementById('efCfg');
  if(!boxes.length||!cfg)return;
  var desktop=window.matchMedia('(min-width: 1024px)'),coarse=window.matchMedia('(pointer: coarse)');
  var RELAY='https://ef-photo-relay.danielzajacus.workers.dev';
  var session=null,creating=false,polling=false,timer=null,qrPromise=null,away=false,createErrors=0,connection='idle';
  var names=['Full fireplace','Width',cfg.dataset.arch==='true'?'Center peak height':'Height'];
  function eligible(){return desktop.matches&&!coarse.matches;}
  function wanted(){var review=document.getElementById('efCfgStepReview');return eligible()&&!away&&document.visibilityState!=='hidden'&&(!review||review.classList.contains('is-visible'));}
  function state(message){boxes.forEach(function(b){var s=b.querySelector('[data-efx-uqr-state]');if(s.textContent!==message)s.textContent=message;});}
  function controls(retry){boxes.forEach(function(b){var x=b.querySelector('[data-efx-uqr-start]');x.hidden=!retry;x.disabled=creating||polling;});}
  function placeholder(message){boxes.forEach(function(b){var q=b.querySelector('[data-efx-uqr-box]');if(q){q.replaceChildren();q.textContent=message;}b.setAttribute('aria-busy',String(connection==='preparing'));});}
  boxes.forEach(function(b){
    var s=b.querySelector('[data-efx-uqr-state]');
    if(!s){s=document.createElement('p');s.setAttribute('data-efx-uqr-state','');s.className='efx-uphoto__qrstate';b.appendChild(s);}
    s.setAttribute('role','status');s.setAttribute('aria-live','polite');
    var button=document.createElement('button');button.type='button';button.className='ef-cfg-btn ef-cfg-btn--back';button.hidden=true;
    button.setAttribute('data-efx-uqr-start','');button.textContent='Retry connection';button.addEventListener('click',function(){createErrors=0;wake();});b.appendChild(button);
  });
  function current(r){return session===r&&!r.closed;}
  function cancelTimer(){clearTimeout(timer);timer=null;}
  function schedule(delay){cancelTimer();if(wanted())timer=setTimeout(function(){timer=null;tick();},delay);}
  function request(r,url,options){
    var c=new AbortController();r.controllers.push(c);var t=setTimeout(function(){c.abort();},12000);
    return fetch(url,Object.assign({cache:'no-store',credentials:'omit',referrerPolicy:'no-referrer'},options,{signal:c.signal}))
      .finally(function(){clearTimeout(t);r.controllers=r.controllers.filter(function(x){return x!==c;});});
  }
  function qr(){
    if(window.QRCode)return Promise.resolve();if(qrPromise)return qrPromise;
    qrPromise=new Promise(function(resolve,reject){
      var script=document.createElement('script'),finished=false;
      function done(error){if(finished)return;finished=true;clearTimeout(timeout);script.onload=script.onerror=null;if(error){script.remove();reject(error);}else resolve();}
      var timeout=setTimeout(function(){done(Error('qr'));},12000);
      script.src='https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';script.referrerPolicy='no-referrer';
      script.onload=function(){done(window.QRCode?null:Error('qr'));};script.onerror=function(){done(Error('qr'));};document.head.appendChild(script);
    }).catch(function(e){qrPromise=null;throw e;});return qrPromise;
  }
  function progress(){
    var api=window._efCfgState,urls=api&&api.photoURLs||[],n=urls.filter(Boolean).length;
    return n?n+' of 3 photos attached'+(urls[0]?'.':'. Add the full fireplace photo.'):'Keep this build open.';
  }
  async function start(){
    if(creating||polling||!wanted())return;
    creating=true;connection='preparing';controls(false);placeholder('Preparing QR…');state('Connecting to your phone…');
    if(session){session.closed=true;session.controllers.forEach(function(c){c.abort();});}
    var r={closed:false,controllers:[],seen:{},errors:0,expires:0,ready:false};session=r;
    var ready=false;
    try{
      var theme=window.Shopify&&window.Shopify.theme;if(!theme||!/^\d+$/.test(String(theme.id)))throw Error('theme');
      var response=await request(r,RELAY+'/session?n=3',{method:'POST'});if(!response.ok)throw Error('session');
      var data=await response.json();if(!current(r))return;
      if(!/^[a-z0-9]{6,16}$/.test(data.token))throw Error('token');
      var phone=new URL(data.phone);if(phone.origin!==RELAY||phone.pathname!=='/p/'+data.token)throw Error('phone');
      r.token=data.token;r.expires=Date.now()+Math.min(Math.max(Number(data.ttl)||900,1),900)*1000;
      var url=new URL('/',location.origin);url.searchParams.set('view','fit-photo');url.searchParams.set('preview_theme_id',String(theme.id));url.searchParams.set('session',r.token);
      var upload=document.getElementById('efCfgUpload');if(upload&&upload.dataset.mainRequired==='true')url.searchParams.set('required','1');if(cfg.dataset.arch==='true')url.searchParams.set('arch','1');
      await qr();if(!current(r))return;
      boxes.forEach(function(b){var q=b.querySelector('[data-efx-uqr-box]');if(q){q.replaceChildren();new window.QRCode(q,{text:url.href,width:136,height:136,colorDark:'#121212',colorLight:'#ffffff',correctLevel:window.QRCode.CorrectLevel.M});}b.setAttribute('aria-busy','false');});
      r.ready=true;ready=true;createErrors=0;connection='ready';state(progress());
    }catch(e){
      if(!current(r))return;
      connection='error';createErrors++;placeholder('QR unavailable');state('Phone connection unavailable. Upload here, or retry.');
    }finally{
      creating=false;controls(!ready);
      if(ready)schedule(0);else if(createErrors<=3)schedule([2000,5000,10000][createErrors-1]||2000);
    }
  }
  async function poll(r){
    if(polling||creating||!current(r)||!wanted())return;
    polling=true;var expired=false;
    try{
      var response=await request(r,RELAY+'/photos/'+r.token);if(response.status===410){expired=true;return;}if(!response.ok)throw Error('network');
      var list=await response.json();if(!Array.isArray(list.ids))throw Error('format');var latest={};
      list.ids.forEach(function(item){if(item&&/^[a-z0-9-]{1,24}$/.test(item.id)&&/^[123]$/.test(String(item.slot)))latest[Number(item.slot)-1]=item;});
      for(var slot=0;slot<3;slot++){
        if(!wanted())break;
        var item=latest[slot];if(!item||r.seen[slot]===item.id)continue;
        var photo=await request(r,RELAY+'/photo/'+r.token+'/'+item.id);if(!photo.ok)throw Error('photo');var blob=await photo.blob();
        if(!current(r))return;if(!blob.size||blob.size>4*1024*1024||!/^image\//i.test(blob.type))throw Error('photo');
        var api=window._efCfgState;if(!api||typeof api.uploadPhoto!=='function')throw Error('upload unavailable');
        connection='receiving';state('Receiving '+names[slot].toLowerCase()+' photo…');
        /* Keep this promise serialized through pause/expiry. Slot version rules
           remain authoritative when a customer replaces/removes an import. */
        var pending=api.uploadPhoto(new File([blob],'fit-'+['fireplace','width','height'][slot]+'-phone.jpg',{type:blob.type}),slot);
        var version=api.photoVersions&&api.photoVersions[slot];
        var uploaded=await pending;
        if(version!==undefined&&api.photoVersions[slot]!==version){r.seen[slot]=item.id;continue;}
        var errors=api.photoErrors;
        if(uploaded===null&&Array.isArray(errors)&&!errors[slot]){r.seen[slot]=item.id;continue;}
        if(typeof uploaded!=='string'||!uploaded||!api.photoURLs||api.photoURLs[slot]!==uploaded)throw Error('upload failed');
        r.seen[slot]=item.id;
      }
      r.errors=0;connection='ready';state(progress());
    }catch(e){
      if(!current(r))return;
      if(!wanted()){connection='ready';return;}
      r.errors++;connection='recovering';state('Connection interrupted. Retrying automatically. You can also upload here.');
    }finally{
      polling=false;
      if(current(r)){
        controls(r.errors>=3);
        if(expired)r.expires=0;
        schedule(expired?0:r.errors?Math.min(30000,2500*Math.pow(2,r.errors)):2500);
      }
    }
  }
  function tick(){
    if(!wanted()||creating||polling)return;
    if(!session||!session.ready||Date.now()>=session.expires){if(createErrors<=3)start();return;}
    poll(session);
  }
  function reconcile(){
    boxes.forEach(function(b){b.hidden=!eligible();});
    if(!wanted()){cancelTimer();return;}
    if(timer===null)tick();
  }
  function wake(){cancelTimer();reconcile();}
  window.addEventListener('ef-cfg:state-changed',reconcile);
  document.addEventListener('visibilitychange',function(){if(document.visibilityState!=='hidden')createErrors=0;wake();});
  window.addEventListener('online',function(){createErrors=0;wake();});
  window.addEventListener('pagehide',function(){away=true;cancelTimer();if(session)session.controllers.forEach(function(c){c.abort();});});
  window.addEventListener('pageshow',function(){away=false;createErrors=0;wake();});
  [desktop,coarse].forEach(function(m){if(m.addEventListener)m.addEventListener('change',reconcile);else m.addListener(reconcile);});
  document.addEventListener('ef:photos:change',function(){if(connection==='ready')state(progress());});
  reconcile();
}());


/* DIRECT-2g — gas-log cards v5. One resolver for every product shape in gas-logs-upsell:
   (a) sizes as VARIANTS (Grand Canyon AWO: option SIZE, a photo per size),
   (b) sizes as sibling PRODUCTS (Real Fyre, Formation Creation: custom.size_siblings; the sibling's variants come from
       /products/<handle>.js when the size changes), each with its own Fuel / Ignition / Burner axes,
   (c) one-size complete kits.
   The size follows #efCfgWidth (longest set ≤ width − 6″, Grand Canyon's 3″ rule) and says so; the other axes default
   to the cheapest available combination (natural gas, match light); price, photo, link and variant follow. */
(function () {
  var cards = [].slice.call(document.querySelectorAll('[data-efx-gls] [data-efx-gl-v5]')); if (!cards.length) return;
  function inches(s) { s = String(s || '').trim(); if (!s) return NaN; var m = s.match(/^(\d+)(?:[\s-]+(\d+)\/(\d+))?/); if (m) { var v = parseFloat(m[1]); if (m[2] && m[3]) v += parseFloat(m[2]) / parseFloat(m[3]); return v; } var f = parseFloat(s.replace(/[^0-9.]/g, '')); return isFinite(f) ? f : NaN; }
  function fmt(c) { c = Math.round(c) / 100; return '$' + (c % 1 ? c.toFixed(2) : c.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function widthIn() { var w = document.getElementById('efCfgWidth'); var v = w ? inches(w.value) : NaN; return isFinite(v) && v > 0 ? v : NaN; }
  function sizeOf(s) { var m = String(s == null ? '' : s).match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; }
  function isSizeName(n) { return /size/i.test(String(n || '')); }
  function wf(n) { return (Math.round(n * 4) / 4).toString(); }
  function uniq(a) { var o = [], m = {}; a.forEach(function (x) { if (x == null || x === '') return; if (!m[x]) { m[x] = 1; o.push(x); } }); return o; }
  function sz(u, w) { u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (j) {
      var fi = j.featured_image || (j.images && j.images[0]) || null;
      return { handle: j.handle, url: '/products/' + j.handle, options: (j.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; }),
        variants: (j.variants || []).map(function (v) { var im = v.featured_image && v.featured_image.src; return { id: v.id, p: v.price, a: !!v.available, o: [v.option1, v.option2, v.option3], img: im ? sz(im, 160) : null, zoom: im ? sz(im, 1200) : null }; }),
        img: fi ? sz(fi, 160) : null, zoom: fi ? sz(fi, 1200) : null };
    });
    return cache[handle];
  }
  cards.forEach(function (card) {
    var base, sibs;
    try { base = { handle: card.getAttribute('data-efx-gl-handle'), url: card.getAttribute('data-efx-gl-url'), options: JSON.parse(card.getAttribute('data-efx-gl-options') || '[]'), variants: JSON.parse(card.getAttribute('data-efx-gl-variants') || '[]') }; sibs = JSON.parse(card.getAttribute('data-efx-gl-siblings') || '[]'); } catch (e) { return; }
    base.options = base.options.map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    var media = card.querySelector('[data-efx-gl-media]');
    var img0 = media && media.querySelector('img'), z0 = media && media.querySelector('[data-efx-zoom]');
    base.img = img0 ? img0.getAttribute('src') : null; base.zoom = z0 ? z0.getAttribute('data-efx-zoom') : null;
    var seen = {}; sibs = sibs.filter(function (s) { var k = sizeOf(s.size); if (!isFinite(k) || seen[k]) return false; seen[k] = 1; s.n = k; return true; }).sort(function (a, b) { return a.n - b.n; });
    var tick = card.querySelector('[data-efx-acc-tick]'), price = card.querySelector('[data-efx-gl-price]'), sizelab = card.querySelector('[data-efx-gl-sizelab]'), fit = card.querySelector('[data-efx-gl-fit]'), more = card.querySelector('[data-efx-gl-more]'), host = card.querySelector('[data-efx-gl-selects]');
    if (!tick || !host) return;
    var prod = base, sizeSel = null, optSels = [], manual = false, lastAxis = -1, sizeRequest = 0;
    var sizeIdx = -1; base.options.forEach(function (n, i) { if (isSizeName(n)) sizeIdx = i; });
    var mode = sizeIdx >= 0 ? 'variant' : (sibs.length > 1 ? 'product' : 'none');
    function mkSel(label) { var s = document.createElement('select'); s.className = 'efx-uac__size'; s.setAttribute('aria-label', label); return s; }
    function buildSize() {
      if (mode === 'none') return;
      sizeSel = mkSel('Set length');
      var vals = mode === 'variant' ? uniq(base.variants.map(function (v) { return v.o[sizeIdx]; })) : sibs.map(function (s) { return s.n + '"'; });
      vals.sort(function (a, b) { return sizeOf(a) - sizeOf(b); });
      vals.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = String(sizeOf(v)) + '\u2033'; sizeSel.appendChild(o); });
      host.appendChild(sizeSel);
      sizeSel.addEventListener('change', function () { manual = true; if (mode === 'product') loadSize(sizeOf(sizeSel.value)).then(function (applied) { if (applied !== false) { cheapest(); paint(); } }); else { cheapest(); paint(); } });
    }
    function buildOpts() {
      optSels.forEach(function (s) { s.remove(); }); optSels = [];
      prod.options.forEach(function (n, i) {
        if (isSizeName(n) || /^title$/i.test(n) || /burner/i.test(n)) return;   /* DIRECT-2p — no Burner choice; G4 (cheapest) is the default */
        var vals = uniq(prod.variants.map(function (v) { return v.o[i]; }));
        if (vals.length < 2) return;
        var s = mkSel(n); s.setAttribute('data-efx-gl-axis', i);
        /* DIRECT-2m — labels: "Safety Pilot +$216" → "Safety Pilot", "Propane(Match Lit is Not Available)" → "Propane" */
        vals.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = String(v).replace(/\s*\+\s*\$[\d.,]+\s*$/, '').replace(/\s*\([^)]*\)\s*/g, ' ').replace(/\s+/g, ' ').trim(); s.appendChild(o); });
        s.addEventListener('change', function () { lastAxis = i; paint(); });   /* DIRECT-2m — the axis just touched wins a tie */
        host.appendChild(s); optSels.push(s);
      });
    }
    function chosen() { var o = []; if (mode === 'variant' && sizeSel) o[sizeIdx] = sizeSel.value; optSels.forEach(function (s) { o[parseInt(s.getAttribute('data-efx-gl-axis'), 10)] = s.value; }); return o; }
    function resolve() {
      var o = chosen();
      var exact = null;
      for (var i = 0; i < prod.variants.length; i++) { var v = prod.variants[i], ok = true; for (var k = 0; k < o.length; k++) { if (o[k] != null && v.o[k] !== o[k]) { ok = false; break; } } if (ok && (!exact || (v.a && !exact.a) || (v.a === exact.a && v.p < exact.p))) exact = v; }   /* DIRECT-2p — cheapest of the matches (an unchosen axis such as Burner resolves to G4) */
      if (exact) return exact;
      /* DIRECT-2m — no such combination (e.g. Propane + Match Lit): keep the size, take the closest real variant
         and move the selects to it, so the price never belongs to a different set than the words. */
      var best = null, bestScore = -1;
      for (var j = 0; j < prod.variants.length; j++) { var w = prod.variants[j]; if (!w.a) continue; if (sizeIdx >= 0 && o[sizeIdx] != null && w.o[sizeIdx] !== o[sizeIdx]) continue; var sc = 0; for (var q = 0; q < o.length; q++) if (o[q] != null && w.o[q] === o[q]) sc += (q === lastAxis ? 10 : 1); if (sc > bestScore || (sc === bestScore && best && w.p < best.p)) { best = w; bestScore = sc; } }
      if (best) optSels.forEach(function (s) { var k = parseInt(s.getAttribute('data-efx-gl-axis'), 10); for (var i2 = 0; i2 < s.options.length; i2++) if (s.options[i2].value === best.o[k]) { s.selectedIndex = i2; break; } });
      return best || prod.variants[0] || null;
    }
    function cheapest() {
      var szv = (mode === 'variant' && sizeSel) ? sizeSel.value : null, best = null;
      prod.variants.forEach(function (v) { if (!v.a) return; if (szv != null && v.o[sizeIdx] !== szv) return; if (!best || v.p < best.p) best = v; });
      if (!best) return;
      optSels.forEach(function (s) { var k = parseInt(s.getAttribute('data-efx-gl-axis'), 10); for (var i = 0; i < s.options.length; i++) if (s.options[i].value === best.o[k]) { s.selectedIndex = i; break; } });
    }
    function curSize() { return sizeSel ? sizeOf(sizeSel.value) : NaN; }
    function paint() {
      var v = resolve(); if (!v) { tick.disabled = true; if (price) price.textContent = '\u2014'; return; }
      var s = curSize();
      tick.disabled = !v.a; tick.setAttribute('data-variant-id', v.id); tick.setAttribute('data-price', v.p);
      tick.setAttribute('data-name', (card.getAttribute('data-efx-gl-name') || '') + (isFinite(s) ? ' ' + s + '"' : ''));
      if (price) price.textContent = fmt(v.p);
      if (sizelab) sizelab.textContent = isFinite(s) ? ' \u00b7 ' + s + '\u2033' : '';
      var src = v.img || prod.img, zoom = v.zoom || prod.zoom;
      if (media) { var im = media.querySelector('img'); if (im && src && im.getAttribute('src') !== src) im.src = src; var zb = media.querySelector('[data-efx-zoom]'); if (zb && zoom) zb.setAttribute('data-efx-zoom', zoom); }
      if (more) more.href = prod.url + (prod.variants.length > 1 ? '?variant=' + v.id : '');
      if (fit && mode !== 'none') {
        var w = widthIn();
        if (!isFinite(w)) fit.textContent = 'Sized to your opening once you type the width.';
        else if (isFinite(s)) fit.textContent = manual ? 'Your opening is ' + wf(w) + '\u2033 wide \u2014 this set leaves ' + wf((w - s) / 2) + '\u2033 each side.' : 'Recommended for your ' + wf(w) + '\u2033 opening \u2014 the longest set that leaves 3\u2033 each side.';
      }
      var mod = card.closest('[data-efx-uac]'); if (mod) mod.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function loadSize(n) {
      var request = ++sizeRequest, s = null;
      sibs.forEach(function (x) { if (x.n === n) s = x; });
      var handle = s ? s.handle : base.handle;
      /* Most keystrokes stay within the same recommended set size. Reuse its
         selectors instead of removing/recreating them inside hidden review. */
      if (handle === prod.handle) return Promise.resolve(true);
      if (handle === base.handle) { prod = base; buildOpts(); return Promise.resolve(true); }
      if (s.img && media) { var im = media.querySelector('img'); if (im) im.src = sz(s.img, 160); }
      return fetchProduct(handle).then(function (pd) {
        if (request !== sizeRequest) return false;
        prod = pd; buildOpts(); return true;
      }).catch(function () {
        if (request !== sizeRequest) return false;
        prod = base; buildOpts(); return true;
      });
    }
    function fromWidth() {
      manual = false;
      var w = widthIn();
      if (sizeSel && isFinite(w)) { var best = -1, bestL = -1, smallest = -1, smallL = 1e9; for (var i = 0; i < sizeSel.options.length; i++) { var L = sizeOf(sizeSel.options[i].value); if (!isFinite(L)) continue; if (L < smallL) { smallL = L; smallest = i; } if (L <= w - 6 && L > bestL) { best = i; bestL = L; } } sizeSel.selectedIndex = best >= 0 ? best : smallest;
        /* DIRECT-2m — the recommended size is named in the list itself */
        for (var i3 = 0; i3 < sizeSel.options.length; i3++) { var op = sizeSel.options[i3]; var baseTxt = String(sizeOf(op.value)) + '\u2033'; var label = i3 === sizeSel.selectedIndex ? baseTxt + ' \u00b7 recommended' : baseTxt; if (op.textContent !== label) op.textContent = label; } }
      if (mode === 'product' && sizeSel) loadSize(sizeOf(sizeSel.value)).then(function (applied) { if (applied !== false) { cheapest(); paint(); } }); else { cheapest(); paint(); }
    }
    buildSize(); buildOpts();
    if (mode === 'product' && sizeSel) { var own = sizeOf((base.handle.match(/^(\d+)-/) || [])[1]); if (isFinite(own)) for (var i = 0; i < sizeSel.options.length; i++) if (sizeOf(sizeSel.options[i].value) === own) sizeSel.selectedIndex = i; }
    efAccWidthQueue(fromWidth);
    fromWidth();
  });
}());

/* DIRECT-2q — swatch row → hidden [data-efx-finish] input (the finish handler listens for its change) */
(function () {
  [].slice.call(document.querySelectorAll('[data-efx-finrow]')).forEach(function (row) {
    var inp = row.querySelector('[data-efx-finish]'), name = row.querySelector('[data-efx-fin-name]'), btns = [].slice.call(row.querySelectorAll('[data-efx-fin]'));
    if (!inp) return;
    btns.forEach(function (b) { b.addEventListener('click', function () {
      btns.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      var v = b.getAttribute('data-efx-fin') || ''; if (name) name.textContent = v; inp.value = v; inp.dispatchEvent(new Event('change', { bubbles: true }));
    }); });
  });
}());
